module.exports = __webpack_public_path__ + "static/mindwave-drone-a861973ac5b4743953b7a7f9be0676ee.jpg";